import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    AppBar, Toolbar, Typography, Grid, IconButton, Tooltip,
} from '@material-ui/core';
import ButtonBase from 'components/controls/ButtonBase';
import BaseModal from 'components/dialogs/BaseModal';
import { ReactComponent as HeinsohnLogo } from 'assets/images/logoHeinsohn.svg';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { abreviaturas, masterMessages, masterEvents } from 'constantes';
import { useHistory } from 'react-router-dom';
import { AnalyticsAmplitud } from 'utils/Analytics-Amplitud';
import authService from 'auth/AuthService';

// Estilos de la pagina
const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
    logo: {
        marginTop: 25,
    },
    logoutIcon: {
        width: '100%',
        background: 'linear-gradient(90deg, #E02A58, #C00333)',
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        color: '#FFFFFF',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '0.625rem',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        marginTop: '1.25rem',
        textTransform: 'capitalize',
        fontWeight: '600',
        cursor: 'pointer',
    },
}));

function HeaderBase({ openModalCancel }) {
    const classes = useStyles();
    const history = useHistory();
    // Mensajes mostrar
    const { auth: { modalLogoutConfirm }, buttons } = masterMessages;
    const [modalConfirm, setModalConfirm] = useState(false);

    // Eventos para modal
    const handleOpenModalCancel = () => setModalConfirm(true);
    const handleCloseModal = () => setModalConfirm(false);

    /**
     * @name logOut
     * @desc Realiza el deslogueo del aplicativo por parte del usuario
     */
    const logOut = async () => {
        authService.logout();
        // Conexión con analiticas al salir del aplicativo
        AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_TERMINAT_SESION);
        history.push('/apiv1/sign-in');
    };

    return (
      <>
        <div className={classes.root}>
          <AppBar position="static" color="primary">
            <Toolbar variant="dense" style={{ background: '#FFFF', color: '#53546A' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={8} xl={8}>
                  <Typography variant="h6" color="inherit">
                    <HeinsohnLogo className={classes.logo} />
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4} xl={4}>
                  <Grid container spacing={3} alignItems="center" justifyContent="center" style={{ marginBottom: 2 }}>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                      <ButtonBase
                        caption="Cancelar firma"
                        colorBase={abreviaturas.DEFAULT_WHITE_COLOR}
                        onClickEvent={openModalCancel}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                      <Tooltip title={buttons.exitLowerCase}>
                        <IconButton
                          className={classes.logoutIcon}
                          color="inherit"
                          aria-label="menu"
                          onClick={handleOpenModalCancel}
                        >
                          <ExitToAppIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </div>

        {Boolean(modalConfirm) && (
          <BaseModal
            open
            onClose={handleCloseModal}
            title={modalLogoutConfirm.title}
            maxWidth="sm"
          >
            <Grid container>
              <Grid item sm={12} md={12} xl={12}>
                <h5>{modalLogoutConfirm.message}</h5>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption={buttons.exit}
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                    onClickEvent={logOut}
                  />
                </Grid>
              </Grid>
            </Grid>
          </BaseModal>
          )}
      </>
    );
}

HeaderBase.defaultProps = {
    openModalCancel: null,
};

HeaderBase.propTypes = {
    // Funcion que abre la modal de cancelar
    openModalCancel: PropTypes.func,
};

export default HeaderBase;
